module.exports = __webpack_public_path__ + "media/img/Landing_Page/s2u-landing-institutions-f65877f4cfe0fc999b02e1a76f2a8545.svg";